import React from "react";
import { BlobProvider, PDFDownloadLink } from "@react-pdf/renderer";
import ConversationPDF from "./ConversationPDF";
import { useEffect, useState } from 'react';
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { analytic } from "../utils/Analytics";
import { getDateTime, getTimestamp } from "../utils/dateTime";
import axios from "../utils/axiosConfig";
import { useFileAttachments } from "../hooks/useFileAttachments.js";

const Menu = ({ showHeaderMenu, setShowHeaderMenu, messages, primary, bot, languages, botLanguages, handleShowMenu, langToast, fetchInfo, handleLanguageClick, handlePromptsMenu, handleRefresh, domain, prompts, voiceMode, botId, publicMode, chatId, showClearConversation }) => {

    const apiURL = process.env.REACT_APP_API_URL;
    const apiKey = process.env.REACT_APP_BOT_API_KEY;

    const { t, i18n } = useTranslation();
    const { fileSharingEnabled, handleAttachmentTrigger } = useFileAttachments();

    const [selectedLanguage, setSelectedLanguage] = useState();
    const [showLanguage, setShowLanguage] = useState(false);
    const [copied, setCopied] = useState(false);
    const [pdfDownloading, setPdfDownloading] = useState(false);

    const handleLanguages = () => {
        setShowLanguage(!showLanguage);
        setShowHeaderMenu(showLanguage);
    }

    const handleLanguageChange = (language) => {
        handleLanguageClick(language);
        setShowLanguage(!showLanguage);
        // setSelectedLanguage(language.name);
        // toast.loading(t('Language changing'), {
        //     id: 'language',
        //     position: 'top-right',
        //     style: {
        //         backgroundColor: 'white',
        //         color: primary,
        //         fontSize: '13px',
        //         padding: '5px 7px',
        //         fontWeight: '500'
        //     }
        // })
        // fetchInfo();
        // i18n.changeLanguage(language.value);

        // localStorage.setItem('language',language.value)
    };

    const [dateInfo, setDateInfo] = useState('');

    useEffect(() => {
        setDateInfo(getDateTime());
    })

    const downloadConversationPDF = async (chatId) => {
        let loadingToast;
        try {
            setPdfDownloading(true);

            const widgetDomain = domain || window.location.host;

            const redirectUrl = `http://${widgetDomain}/${publicMode ? `?bot=${botId}&voiceMode=${voiceMode}` : widgetDomain.includes('creator') ? `agents/${bot.slug}/?id=${bot.id}` : ''}`;

            const pdfUrl = `${apiURL}/get_conversation_pdf?chat_id=${chatId}&redirect_url=${redirectUrl}`;

            handleShowMenu();

            loadingToast = toast.loading(t('Downloading PDF...'), {
                position: 'top-right',
                style: {
                    backgroundColor: 'white',
                    color: primary,
                    fontSize: '13px',
                    padding: '5px 7px',
                    fontWeight: '500'
                },
                iconTheme: {
                    primary: primary
                }
            })

            const response = await axios({
                url: pdfUrl,
                method: 'GET',
                headers: {
                    'Api-token': apiKey,
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });

            toast.dismiss(loadingToast);

            setPdfDownloading(false);

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `chat_${bot.name}_${chatId.slice(-4)}_${getTimestamp()}.pdf`;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            handlePDFDownload();

            return response;
        } catch (error) {
            toast.dismiss(loadingToast);

            setPdfDownloading(false);

            console.error('Error downloading PDF:', error);

            toast.error(t('Failed to download PDF. Please try again.'), {
                position: 'top-right',
                style: {
                    backgroundColor: 'white',
                    color: 'red',
                    fontSize: '13px',
                    padding: '5px 7px',
                    fontWeight: '500'
                }
            });
        }
    };

    const handlePDFDownload = () => {

        let data = {
            share_type: 'conversation'
        }

        analytic("share_event", data);

        toast(t('PDF Downloaded'), {
            duration: 1500,
            position: 'top-right',
            style: {
                backgroundColor: 'white',
                color: primary,
                fontSize: '13px',
                padding: '5px 7px',
                fontWeight: '500'
            }
        })
    }

    useEffect(() => {
        const lang = languages.find((lng) => lng.value === i18n.language);

        setSelectedLanguage(lang);

    }, [i18n.language]);

    const handleCopyChatId = () => {
        if (copied) return;

        navigator.clipboard.writeText(chatId);
        setCopied(true);
        toast.success(t('Chat ID copied to clipboard'));

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    }

    return (
        <>
            <div className={`bg-[rgba(0,0,0,0.7)] fixed z-10 flex justify-end flex-col h-full w-full ${showHeaderMenu ? 'show-menu' : 'hide-menu'}`} onClick={handleShowMenu}>

            </div>
            <div className={`menu-ct p-2 dark:!bg-[#232326] bg-white transition ease-in-out rounded-t-xl duration-500 z-30 shadow-md  w-full fixed left-[0px] bottom-0 ${showHeaderMenu ? 'show-menu' : 'hide-menu'}`}>
                {/* <p className="mb-2 text-[12px] leading-[12px] cursor-pointer" onClick={downloadPDF}>Share entire conversation (Image)</p>
                <PDFDownloadLink document={<ConversationPDF messages={messages} />} fileName="Chat.pdf" className="text-[12px] text-black no-underline cursor-pointer">
                    <p className="mb-2 text-[12px] leading-[12px]">Share entire conversation</p>
                </PDFDownloadLink>
                <p className="mb-1 text-[12px] leading-[12px]">Privacy Policy</p> */}

                {/* <div className="menu-item flex items-center justify-start p-[8px] cursor-pointer" onClick={downloadPDF}>
                    <p className="mb-0 ml-0 text-[13px] leading-[16px] font-normal" style={{ color: primary }}>Share entire conversation (Image)</p>
                </div> */}

                <div className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-between p-[10px] disabled:opacity-50 disabled:cursor-not-allowed w-full`}>
                    <button className="cursor-pointer border-none bg-transparent p-0" onClick={handleCopyChatId}>
                        <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Chat ID')}</p>
                    </button>
                    <button className="flex items-center justify-center gap-4 cursor-pointer border-none bg-transparent p-0 color-primary" onClick={handleCopyChatId}>
                        <p className="mb-0 ml-0 dark:!text-white text-black text-[12px] md:text-[13px] leading-[14px] font-normal">{chatId}</p>
                        {
                            copied ? (
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="18" height="18">
                                    <path d="M 26.980469 5.9902344 A 1.0001 1.0001 0 0 0 26.292969 6.2929688 L 11 21.585938 L 4.7070312 15.292969 A 1.0001 1.0001 0 1 0 3.2929688 16.707031 L 10.292969 23.707031 A 1.0001 1.0001 0 0 0 11.707031 23.707031 L 27.707031 7.7070312 A 1.0001 1.0001 0 0 0 26.980469 5.9902344 z" stroke={'currentColor'} />
                                </svg>
                            ) : (
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.4 11.4H2.6C2.17565 11.4 1.76869 11.2314 1.46863 10.9314C1.16857 10.6313 1 10.2243 1 9.8V2.6C1 2.17565 1.16857 1.76869 1.46863 1.46863C1.76869 1.16857 2.17565 1 2.6 1H9.8C10.2243 1 10.6313 1.16857 10.9314 1.46863C11.2314 1.76869 11.4 2.17565 11.4 2.6V3.4" stroke={'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M15.4001 6.59998H8.2001C7.31644 6.59998 6.6001 7.31632 6.6001 8.19998V15.4C6.6001 16.2836 7.31644 17 8.2001 17H15.4001C16.2838 17 17.0001 16.2836 17.0001 15.4V8.19998C17.0001 7.31632 16.2838 6.59998 15.4001 6.59998Z" stroke={'currentColor'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )
                        }
                    </button>
                </div>
                <button className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-start p-[10px] cursor-pointer border-none bg-transparent w-full disabled:opacity-50 disabled:cursor-not-allowed`} onClick={() => downloadConversationPDF(chatId)} disabled={pdfDownloading}>
                    {/* <PDFDownloadLink document={<ConversationPDF chatId={chatId} messages={messages} bot={bot} botId={botId} voiceMode={voiceMode} publicMode={publicMode} dateInfo={dateInfo} primary={primary} domain={domain || window.location.host} />} fileName="Chat.pdf" className="text-[12px] text-black no-underline cursor-pointer" onClick={handlePDFDownload}> */}
                        <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Share conversation')}</p>
                    {/* </PDFDownloadLink> */}
                    {/* <BlobProvider document={<ConversationPDF messages={messages} bot={bot} dateInfo={dateInfo} />}>
                        {({ url, ...rest }) => {
                            return (
                                <a href={url} target="_blank" className="no-underline">
                                    <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium" style={{ color: primary }}>Share entire conversation</p>
                                </a>
                            )
                        }}
                    </BlobProvider> */}
                </button>
                {fileSharingEnabled && (
                    <button
                        className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-start p-[10px] cursor-pointer border-none bg-transparent w-full disabled:opacity-50 disabled:cursor-not-allowed`}
                        onClick={() => {
                            handleShowMenu();
                            handleAttachmentTrigger();
                        }}
                        disabled={!localStorage.getItem(`initialLanguageSet_${botId}`)}
                    >
                        <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Upload files')}</p>
                    </button>
                )}
                <div className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-between p-[10px] pr-0 cursor-pointer`}>
                    <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Select language')}</p>
                    <button className='mr-[0px] flex items-center justify-center border-none bg-transparent color-primary' onClick={handleLanguages}>
                        <p className={`px-2 rounded-2xl mb-0 dark:!text-white text-black text-[12px] leading-[12px] pb-[1px]`} >{selectedLanguage?.name}</p>
                        {/* <img src="/assets/images/right-arrow-ic.svg" alt="right arrow" className="h-[10px]" /> */}
                        <svg width="10" height="12" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L9 9L1 17" stroke={'currentColor'} />
                        </svg>
                    </button>
                </div>
                <button className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-start p-[10px] cursor-pointer border-none bg-transparent disabled:opacity-50 disabled:cursor-not-allowed w-full`} onClick={handlePromptsMenu}>
                    <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Try asking')}</p>
                </button>
                {showClearConversation && <div className={`${selectedLanguage?.id == 'arabic' && 'flex-row-reverse'} menu-item flex items-center justify-start p-[10px] cursor-pointer`} onClick={handleRefresh}>
                    <p className="mb-0 ml-0 text-[13px] leading-[16px] font-medium color-primary">{t('Clear conversation')}</p>
                </div>}
            </div>
            <div className={`fixed top-0 w-full h-full z-20 ${showLanguage ? 'block' : 'hidden'}`} onClick={handleLanguages}>
                <div className='bg-[rgba(0,0,0,0.7)] flex justify-end flex-col h-full w-full'>

                </div>
            </div>
            <div className={`language-ct rounded-t-xl dark:!bg-[#232326] bg-white p-3 pb-2 transition ease-in-out duration-500 divide-y divide-[#000000] w-full fixed bottom-0 left-0 z-50 ${showLanguage ? 'show-lang-menu' : 'hide-lang-menu'}`}>
                <div className="flex justify-start items-center mb-3">
                    <a className="cursor-pointer color-primary" onClick={handleLanguages}>
                        <svg width="16" height="16" viewBox="0 0 18 18" fill={'currentColor'} xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" />
                        </svg>
                    </a>
                    <h2 className={`font-semibold flex-1 text-[15px] pb-[0] mx-[10px] my-0 text-black dark:!text-white text-${selectedLanguage?.id == 'arabic' ? 'right' : 'left'} ${selectedLanguage?.id == 'arabic' && 'mr-0'}`}>{t('Select language')}</h2>
                </div>
                <ul className='language-list list-none p-0 max-h-[140px] overflow-y-auto '>
                    {languages
                        .filter((lng) => botLanguages.includes(lng.value))
                        .map((lng) => (
                            <li className={`py-[10px] text-[13px] border-b border-gray-400 cursor-pointer ${lng?.id === selectedLanguage?.id ? 'color-primary'  : 'text-[#333333]'} text-${selectedLanguage?.id == 'arabic' ? 'left': 'left'}`} key={lng?.id} value={lng.value} onClick={lng?.id === selectedLanguage?.id ? null : () => handleLanguageChange(lng)}>
                                {/* {t(`${lng.name}`)} */}
                                {lng?.name}
                            </li>
                        ))}
                </ul>
            </div>
        </>

    )
}

export default Menu;